import React from "react";

/**
 * Reusable Decorative Grid Lines Component - Variant 5 (End / Finish Game Page)
 *
 * Design Spec:
 * - 6 Rows x 12 Columns Grid
 * - Row 1 (Top): 2/3 normal box height (2fr), full row boxes
 * - Rows 2..5 (Middle 4 rows):
 *   - Cols 2-4 & 8-10: Vertical lines hidden
 *   - Cols 2-5 & 8-11: Horizontal bottom lines hidden
 * - Row 6 (Bottom): 1/3 normal box height (1fr), full row boxes
 * - Column 1 & 12: 1/2 normal box width (0.5fr)
 * - Columns 2..11: 1fr normal box width
 *
 * @param {string} variant - Optional layout variant name
 * @param {string} label - Optional target node label
 */
const DecorativeLines5 = ({ variant = "default", label = "" }) => {
    const rows = [1, 2, 3, 4, 5, 6];
    const cols = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    /**
     * Determines if the vertical right border of column `colIndex` in `rowIndex` should be omitted (empty space)
     */
    const isVerticalLineHidden = (rowIndex, colIndex) => {
        // ONLY for middle rows 2, 3, 4, 5
        if (rowIndex >= 2 && rowIndex <= 5) {
            // Columns 2..4 and Columns 8..10 are empty (vertical lines hidden)
            if (
                (colIndex >= 2 && colIndex <= 4) ||
                (colIndex >= 8 && colIndex <= 10)
            ) {
                return true;
            }
        }
        return false;
    };

    /**
     * Determines if the horizontal bottom border of cell (`rowIndex`, `colIndex`) should be omitted
     */
    const isHorizontalLineHidden = (rowIndex, colIndex) => {
        // ONLY for middle rows 2, 3, 4, 5
        if (rowIndex >= 2 && rowIndex <= 5) {
            // Columns 2..5 and Columns 8..11 have no horizontal bottom line
            if (
                (colIndex >= 2 && colIndex <= 5) ||
                (colIndex >= 8 && colIndex <= 11)
            ) {
                return true;
            }
        }
        return false;
    };

    return (
        <div className={`DecorativeLines5 DecorativeLines5--${variant}`}>
            <div className="DecorativeLines5__grid">
                {rows.map((rowIndex) => (
                    <div
                        key={`row-${rowIndex}`}
                        className={`DecorativeLines5__row DecorativeLines5__row--${rowIndex}`}
                    >
                        {cols.map((colIndex) => {
                            const hideRightBorder = isVerticalLineHidden(
                                rowIndex,
                                colIndex,
                            );
                            const hideBottomBorder = isHorizontalLineHidden(
                                rowIndex,
                                colIndex,
                            );
                            const isHalfCol = colIndex === 1 || colIndex === 12;

                            return (
                                <div
                                    key={`cell-${rowIndex}-${colIndex}`}
                                    className={`DecorativeLines5__cell ${
                                        isHalfCol
                                            ? "DecorativeLines5__cell--half"
                                            : ""
                                    } ${
                                        hideRightBorder
                                            ? "DecorativeLines5__cell--no-v-line"
                                            : ""
                                    } ${
                                        hideBottomBorder
                                            ? "DecorativeLines5__cell--no-h-line"
                                            : ""
                                    }`}
                                />
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DecorativeLines5;
